import React, { Component } from "react";
import { withLeaflet } from "react-leaflet";
import L from "leaflet";
import 'leaflet-imageoverlay-rotated';


class ImageOverlayRotated extends Component {
    state={
        capa: null,
        map: null
    }

    componentDidMount() {
        const {map} = this.props.leaflet;
        this.setState({map: map})

        if (this.state.capa) {
            this.state.capa.removeFrom(map)
            this.setState({capa: null})
        }

        if (this.props.url && this.props.point1 && this.props.point2 && this.props.point3) {
            const overlay = L.imageOverlay.rotated(this.props.url, this.props.point1, this.props.point2, this.props.point3, {
                opacity: 1
            });

            overlay.addTo(map);
            this.setState({capa: overlay})
        }
    }

    componentWillUnmount() {
        if (this.state.capa && this.state.map) {
            this.state.capa.removeFrom(this.state.map)
        }
    }

    render() {
        return null;
    }
}

export default withLeaflet(ImageOverlayRotated);